import styled from 'styled-components';

export const Headline2 = styled.h2`
    font-weight: 600;
    font-size: 24px;
`;
